export default __webpack_public_path__ + "53e8c5520d3fda9fb1d7e12cb0b700b5.jpg";